import React from 'react'
import { Route } from 'react-static'
import { Switch, Redirect } from 'react-router'
import DynamicRoutes from 'react-static-routes'

import Home from './Home'
import Gallery from './Gallery'
import People from './People'
import About from './About'
import Contact from '../components/pages/contact/Contact'
import Login from '../components/pages/login/Login'
import Admin from '../components/admin/Admin'
import NotFound from '../components/pages/notFound/NotFound'

const Routes = ({ latestPostSlug }) => (
  <Switch>
    <Route exact path="/" component={Home} />
    <Route path="/about" component={About} />
    <Route path="/contact" component={Contact} />
    <Route path="/login" component={Login} />
    <Route
      path="/gallery/:section"
      render={props => <Gallery key={props.location.key} {...props} />}
    />
    <Route
      path="/people/:person"
      render={props => <People key={props.location.key} {...props} />}
    />
    <Route path="/admin/:section" render={props => <Admin key={props.location.key} {...props} />} />
    <Redirect exact from="/admin" to="/admin/people" key="from admin" />
    <Redirect exact from="/gallery" to="/gallery/overview" key="from gallery" />
    <Redirect exact from="/people" to="/people/bevan" key="from people" />
    <Route component={NotFound} />
    <DynamicRoutes />
  </Switch>
)

export default Routes



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Routes.js